import Color from "color";
import Link from "next/link";

import { css, styled } from "@mui/material";

import { getColor } from "@hooks";
import TextLogo from "@public/_common/current_color_text_logo.svg";
import { cssPropertiesToString } from "@utils";

interface MenuContainerProps {
  pageNotOnTop: boolean;
  applyBackdropFilter: boolean;
  applyBackgroundColor: boolean;
  fixed?: boolean;
}

export const MenuContainer = styled("div", {
  shouldForwardProp: prop =>
    prop !== "pageNotOnTop" &&
    prop !== "applyBackdropFilter" &&
    prop !== "applyBackgroundColor" &&
    prop !== "fixed",
})<MenuContainerProps>(
  ({
    theme,
    applyBackdropFilter,
    applyBackgroundColor,
    pageNotOnTop,
    fixed,
  }) => css`
    top: 0;
    z-index: 1000;
    width: 100vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition:
      backdrop-filter 0.3s,
      background-color 0.3s,
      padding-top 0.3s;

    ${applyBackgroundColor &&
    `background-color: ${new Color(theme.palette.background.default).opaquer(-0.3)};`}

    ${applyBackdropFilter && "backdrop-filter: blur(20px);"}

    ${theme.breakpoints.up("mobile")} {
      padding: 16px 16px;
      position: sticky;
    }

    ${theme.breakpoints.up("tablet")} {
      padding: 16px 32px;
    }

    ${theme.breakpoints.up("tablet")} {
      padding-top: ${pageNotOnTop ? 16 : 32}px;
      padding-bottom: 16px;
      padding-left: calc(50% - 676px / 2 + 18px);
      padding-right: calc(50% - 676px / 2 + 18px);

      ${fixed
        ? css`
            position: fixed;
            top: 0;
            left: 0;
          `
        : css`
            position: sticky;
          `}
    }

    ${theme.breakpoints.up("desktop")} {
      padding-top: ${pageNotOnTop ? 32 : 48}px;
      padding-bottom: 32px;
      padding-left: calc(50% - 914px / 2 + 21px);
      padding-right: calc(50% - 914px / 2 + 21px);
    }

    ${theme.breakpoints.up("desktopXl")} {
      padding-top: ${pageNotOnTop ? 32 : 52}px;
      padding-bottom: 32px;
      padding-left: calc(50% - 1220px / 2 + 38px);
      padding-right: calc(50% - 1220px / 2 + 38px);
    }
  `,
);

export const TextLogoStyled = styled(TextLogo)(
  ({ theme }) => css`
    ${theme.breakpoints.up("mobile")} {
      scale: calc(128 / 160);
      transform-origin: center left;
      margin-bottom: -2px;
    }

    ${theme.breakpoints.up("tablet")} {
      scale: 1;
    }
  `,
);

export const MenuLinkStyled = styled(Link)(
  ({ theme }) => css`
    ${cssPropertiesToString(theme.typography.paragraph_medium_medium)}
    color: ${getColor(c => c.tokens.text["strong-950"], theme)};
    text-transform: capitalize;
    padding: 16px;

    &:hover {
      text-decoration: underline;
    }
  `,
);
